import { z } from 'zod'

import { afterValid } from '~/services/api/contracts/afterValid'
import { email } from '~/services/api/contracts/email'
import { phone } from '~/services/api/contracts/phone'
import { UserRoleSchema, UserStatusSchema, UserUpdateRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'
import { refinePasswordConfirmation } from '~/services/api/contracts/refinePasswordConfirmation'

const normalize = fieldNormalizer({
  trimmed: ['name', 'last_name', 'email'],
  blankToNull: ['phone'],
  enums: [{ field: 'status', options: UserStatusSchema.options }]
})

const DashboardUpdateUserSchema = UserUpdateRequestSchema.extend({
  email: email(255),
  password_confirmation: z.string().min(1).nullish(),
  phone: phone.nullish(),
  roles: z.tuple([UserRoleSchema]),
  status: UserStatusSchema
}).strict()

const InvitedUserSchema = DashboardUpdateUserSchema.extend({ status: UserStatusSchema.optional() })

interface DashboardUpdateUserContext {
  /** A pending invitation keeps its status; the API accepts the edit without one. */
  readonly invitedUser?: boolean
}

export const DashboardUpdateUser = (context: DashboardUpdateUserContext = {}) =>
  z.preprocess(
    normalize,
    afterValid(
      context.invitedUser === true ? InvitedUserSchema : DashboardUpdateUserSchema,
      refinePasswordConfirmation
    )
  )
